import { css } from "../../../styled-system/css";

const baseBadgeStyles = {
  display: "inline-flex",
  alignItems: "center",
  gap: "4px",
  padding: "4px 12px",
  borderRadius: "100px",
  fontSize: "body.butterfly",
  lineHeight: "body.butterfly",
  letterSpacing: "body.butterfly",
  fontWeight: "bold",
  textTransform: "uppercase",
  border: "1px solid",
  tablet: {
    fontSize: "body.mouse",
    lineHeight: "body.mouse",
    letterSpacing: "body.mouse",
  },
} as const;

const baseInfoTextStyles = {
  fontSize: "body.mouse",
  lineHeight: "body.mouse",
  letterSpacing: "body.mouse",
} as const;

export const styles = {
  root: () =>
    css({
      width: "100%",
      borderRadius: "baseUnit.mobile1",
      boxShadow: "softBottomRight",
      overflow: "hidden",
      backgroundColor: "white",
    }),

  header: () =>
    css({
      display: "flex",
      alignItems: "center",
      gap: "baseUnit.mobile1",
      padding: "baseUnit.mobile2",
      backgroundColor: "springGreen.transparent",
      tablet: {
        gap: "baseUnit.desktop1",
        padding: "baseUnit.desktop2",
      },
    }),

  iconWrapper: () =>
    css({
      marginRight: "4px",
      marginTop: "-4px",
      flexShrink: 0,
    }),

  headerText: () =>
    css({
      fontSize: "heading.H4.mobile",
      lineHeight: "heading.H4.mobile",
      letterSpacing: "heading.H4.mobile",
      fontWeight: "bold",
      margin: 0,
      color: "headlineGrey",
      tablet: {
        fontSize: "heading.H4.desktop",
        lineHeight: "heading.H4.desktop",
        letterSpacing: "heading.H4.desktop",
      },
    }),

  content: () =>
    css({
      display: "flex",
      flexDirection: "column",
      gap: "baseUnit.mobile1",
      padding: "baseUnit.mobile2",
      backgroundColor: "white",
      tablet: {
        gap: "baseUnit.desktop1",
        padding: "baseUnit.desktop2",
      },
    }),

  infoGrid: () =>
    css({
      display: "flex",
      flexDirection: "column",
      gap: "baseUnit.mobile1",
      tablet: {
        display: "flex",
        flexDirection: "row",
        gap: "baseUnit.mobile2",
        flexWrap: "wrap",
      },
    }),

  vinRegWrapper: () =>
    css({
      display: "flex",
      alignItems: "center",
      gap: "4px",
      flexWrap: "wrap",
    }),

  vinRegLabel: () =>
    css({
      ...baseInfoTextStyles,
      fontWeight: "bold",
      color: "headlineGrey",
    }),

  vinRegValue: () =>
    css({
      ...baseInfoTextStyles,
      backgroundColor: "black",
      color: "white",
      padding: "4px 12px",
      borderRadius: "4px",
      fontWeight: "bold",
      userSelect: "all",
    }),

  vehicleWrapper: () =>
    css({
      display: "flex",
      alignItems: "center",
      gap: "baseUnit.mobile1",
      flexWrap: "wrap",
    }),

  vehicleLabel: () =>
    css({
      ...baseInfoTextStyles,
      fontWeight: "bold",
      color: "headlineGrey",
    }),

  vehicleValue: () =>
    css({
      ...baseInfoTextStyles,
      color: "headlineGrey",
    }),

  badgesWrapper: () =>
    css({
      display: "flex",
      alignItems: "center",
      gap: "baseUnit.mobile1",
      flexWrap: "wrap",
      marginTop: "4px",
      tablet: {
        gap: "baseUnit.desktop1",
      },
    }),

  riskBadgeButton: () =>
    css({
      display: "inline-flex",
      alignItems: "center",
      gap: "4px",
      background: "none",
      border: "none",
      padding: 0,
      cursor: "pointer",
    }),

  riskBadge: () =>
    css({
      ...baseBadgeStyles,
      backgroundColor: "red.100",
      borderColor: "red",
      color: "red",
    }),

  infoIcon: () =>
    css({
      display: "flex",
      "& svg": {
        width: "baseUnit.mobile2",
        height: "baseUnit.mobile2",
      },
    }),

  kilometersBadge: () =>
    css({
      ...baseBadgeStyles,
      backgroundColor: "blue.100",
      borderColor: "blue",
      color: "blue",
      visibility: "hidden",
    }),

  badgeDot: () =>
    css({
      width: "8px",
      height: "8px",
      borderRadius: "50%",
      backgroundColor: "red",
      flexShrink: 0,
    }),
};
